import { useTranslation } from "react-i18next";

import { useAuthState, usePos } from "@/app/context";
import type { PosLocale } from "@/i18n";
import { staffLocaleKey, writeSetting } from "@/lib/db";

/**
 * Switch the language and remember it on this tablet (Dexie `settings.locale`) and — when someone
 * is signed in — as that staff member's choice here (T07-34), so it survives the next PIN login.
 */
export function useChangeLanguage(): (locale: PosLocale) => void {
  const { i18n } = useTranslation();
  const { db } = usePos();
  const state = useAuthState();
  return (locale) => {
    void i18n.changeLanguage(locale);
    void writeSetting(db, "locale", locale);
    if (state.kind === "unlocked") {
      void writeSetting(db, staffLocaleKey(state.staff.id), locale);
    }
  };
}
